import { 
  FileText, 
  File, 
  FileImage, 
  FileSpreadsheet, 
  FileArchive,
  FileVideo,
  FileAudio,
  FileCode
} from 'lucide-react'

/**
 * Utility functions for document handling
 * Centralizes document icon and color logic for reusability
 */

/**
 * Get appropriate icon for document type
 * @param {string} type - Document type
 * @returns {React.Component} Icon component
 */
export const getDocumentIcon = (type) => {
  if (!type) return File
  
  const normalizedType = type.toLowerCase()
      
  // Image documents
  if (normalizedType.includes('image') || 
      normalizedType.includes('jpg') || 
      normalizedType.includes('jpeg') || 
      normalizedType.includes('png') || 
      normalizedType.includes('gif') || 
      normalizedType.includes('svg')) return FileImage
  
  // Spreadsheet documents
  if (normalizedType.includes('excel') || 
      normalizedType.includes('spreadsheet') || 
      normalizedType.includes('csv') || 
      normalizedType.includes('xls') || 
      normalizedType.includes('xlsx')) return FileSpreadsheet
  
  // Archive documents
  if (normalizedType.includes('zip') || 
      normalizedType.includes('rar') || 
      normalizedType.includes('archive') || 
      normalizedType.includes('compressed')) return FileArchive
  
  // Video documents
  if (normalizedType.includes('video') || 
      normalizedType.includes('mp4') || 
      normalizedType.includes('avi') || 
      normalizedType.includes('mov')) return FileVideo
  
  // Audio documents
  if (normalizedType.includes('audio') || 
      normalizedType.includes('mp3') || 
      normalizedType.includes('wav') || 
      normalizedType.includes('m4a')) return FileAudio
  
  // Code documents
  if (normalizedType.includes('code') || 
      normalizedType.includes('script') || 
      normalizedType.includes('json') || 
      normalizedType.includes('xml')) return FileCode
  
  // Text documents
  if (normalizedType.includes('text') || 
      normalizedType.includes('txt') || 
      normalizedType.includes('pdf') || 
      normalizedType.includes('doc') || 
      normalizedType.includes('docx')) return FileText
  
  // Default to generic file icon
  return File
}

/**
 * Get color class for document type
 * @param {string} type - Document type
 * @returns {string} Tailwind color class
 */
export const getDocumentColor = (type) => {
  if (!type) return 'text-gray-500'
  
  const normalizedType = type.toLowerCase()
  
  if (normalizedType.includes('pdf')) return 'text-red-500'
  if (normalizedType.includes('image')) return 'text-green-500'
  if (normalizedType.includes('excel') || normalizedType.includes('spreadsheet')) return 'text-green-600'
  if (normalizedType.includes('zip') || normalizedType.includes('archive')) return 'text-purple-500'
  if (normalizedType.includes('video')) return 'text-blue-500'
  if (normalizedType.includes('audio')) return 'text-yellow-500'
  if (normalizedType.includes('code')) return 'text-indigo-500'
  if (normalizedType.includes('text') || normalizedType.includes('doc')) return 'text-blue-600'
  
  return 'text-gray-500'
}
